import { Component } from '@angular/core';
import { AlertController, NavController, NavParams } from 'ionic-angular';
import { GN } from '../../../gn';
import { DIC } from '../../dic';

/**
 * Generated class for the AutomaticroutePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-automaticroute',
  templateUrl: 'automaticroute.html',
})
export class AutomaticroutePage {

  routes = []
  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN, public alertCtrl: AlertController) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AutomaticroutePage');
    this.checkAutomaticRoute()
  }


  checkAutomaticRoute() {
    var _that = this
    this.gn._Post('/api/gn/getAutomaticRoutes', { cid: this.gn.crypt(this.gn.user.ClientId) }, function (_data) {
      for (let i = 0; i < _data.length; i++) {
        _data[i].visible = true
        _data[i].registration = _that.gn.Vehicles[_that.gn.VehiclesDic[_data[i].vehicleid]].registration + ' (' + _that.gn.Vehicles[_that.gn.VehiclesDic[_data[i].vehicleid]].code + ')'
        var nameday = 'autodow' + _data[i].autodow
        _data[i].typeday = _that.dic.l[nameday]
      }

      _that.routes = _data
      console.log(_that.routes, '_that.routes')
      //debugger
    })
  }

  getItems(ev: any) {
    // for (var i=0; i<this.Data.length; i++){
    //   this.Data[i].visible = true
    // }    
    const val = ev.target.value.toLowerCase()
    for (var i = 0; i < this.routes.length; i++) {
      if (val == '') {
        this.routes[i].visible = true
      } else {
        var itm = this.routes[i].name.toLowerCase()
        if (itm.indexOf(val) > -1) {
          this.routes[i].visible = true
        } else {
          this.routes[i].visible = false
        }
      }
    }
  }

  reset(_id, _index) {
    //debugger
    var _that = this
    let alert = _that.alertCtrl.create({
      title: _that.dic.l["resetroute"],
      subTitle: _that.dic.l["areyousureresetroute"] + ' ' + _id,
      buttons: [
        {
          text: _that.dic.l['ok'],
          handler: data => {

            _that.gn.loadWaiting();
            this.gn._Post('/api/gn/resetroute', { id: this.gn.crypt(_id) }, function (_data) {
              _that.routes.splice(_index, 1);
              _that.gn.loaderWaiting.dismiss();
            })
          }
        },
        {
          text: _that.dic.l['cancel'],
          role: 'cancel'
        }
      ]
    });
    alert.present();

  }

}



// WEBPACK FOOTER //
// ./src/pages/routing/automaticroute/automaticroute.ts